export const ORDER_TABLE_COLUMNS = [
  {
    prop: 'selection',
    resizable: false,
    label: '',
    sortable: false,
    width: '30',
    isCustomTemplate: true,
    className: 'selection',
  },
  {
    prop: 'claimData.isProcessed',
    resizable: true,
    label: 'Обработка',
    sortable: 'custom',
    width: 130,
    isCustomTemplate: true,
  },
  {
    prop: 'number',
    resizable: true,
    label: 'Номер заказа на услугу',
    sortable: 'custom',
    width: 220,
  },
  {
    prop: 'productOrderDeliveryStatus',
    resizable: true,
    label: 'Готовность товара к сборке',
    sortable: false,
    width: 220,
  },
  {
    prop: 'amountByService',
    resizable: true,
    label: 'Сумма по артикулам услуг',
    sortable: null,
    width: 220,
    isCustomTemplate: true,
  },
  {
    prop: 'amountByGoods',
    resizable: true,
    label: 'Сумма по товарам',
    sortable: null,
    width: 200,
    isCustomTemplate: true,
  },
  {
    prop: 'orderRows',
    resizable: true,
    label: 'Номера заказов на продажу по услуге',
    sortable: null,
    width: 210,
    isCustomTemplate: true,
  },
  {
    prop: 'contractor.name',
    resizable: true,
    label: 'Подрядчик',
    sortable: 'custom',
    width: 170,
  },
  {
    prop: 'worker.fullName',
    resizable: true,
    label: 'Исполнитель',
    sortable: null,
    width: 170,
  },
  {
    prop: 'workDate',
    resizable: true,
    label: 'Дата оказания услуги',
    sortable: 'custom',
    width: 200,
    isCustomTemplate: true,
  },
  {
    prop: 'claimData.processedAt',
    resizable: true,
    label: 'Дата обработки',
    sortable: 'custom',
    width: 170,
    isCustomTemplate: true,
  },
  {
    prop: 'claimData.createdAt',
    resizable: true,
    label: 'Дата рекламации',
    sortable: 'custom',
    width: 210,
    isCustomTemplate: true,
  },
  {
    prop: 'shop',
    resizable: true,
    label: 'Магазин',
    sortable: 'custom',
    width: 170,
  },
  {
    prop: 'clientName',
    resizable: true,
    label: 'Клиент',
    sortable: 'custom',
    width: 350,
  },
  {
    prop: 'address',
    resizable: true,
    label: 'Адрес',
    sortable: 'custom',
    width: 350,
  },
  {
    prop: 'service.name',
    resizable: true,
    label: 'Тип заказа',
    sortable: 'custom',
    width: 170,
    isCustomTemplate: true,
  },
  {
    prop: 'registryType.name',
    resizable: true,
    label: 'Тип реестра',
    sortable: 'custom',
    width: 170,
    isCustomTemplate: true,
  },
  {
    prop: 'status.title',
    resizable: true,
    label: 'Статус заказа',
    sortable: 'custom',
    width: 170,
  },
  {
    prop: 'cancellationData.reason',
    resizable: true,
    label: 'Причина отмены',
    sortable: 'custom',
    width: 170,
  },
];
